import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listOnAir } from '../api/portal';
import { ApiError } from '../api/client';
import { copyText } from '../lib/clipboard';

function demoHref(matches: { onair_url?: string; demo_url?: string }[] | undefined) {
  const first = matches?.[0];
  if (first?.demo_url) return first.demo_url.split('?')[0];
  try {
    if (first?.onair_url) return `${new URL(first.onair_url).origin}/demo/delivery`;
  } catch { /* keep fallback */ }
  return 'https://app.origo.rs/demo/delivery';
}

function live(status: string) {
  return status.startsWith('in_play') || status === 'break' || status === 'suspended';
}

export function OnAirPage() {
  const q = useQuery({ queryKey: ['portal-onair'], queryFn: listOnAir, refetchInterval: 15_000 });
  const [msg, setMsg] = useState<string | null>(null);
  const copy = async (url: string) => {
    await copyText(url);
    setMsg('URL kopiran — stavi ga u OBS Browser source.');
  };

  return (
    <div>
      <div className="page-head">
        <div className="page-kicker">Delivery</div>
        <h1 className="page-title">Origo On-Air</h1>
        <p className="page-sub">
          Jedan URL po meču za OBS / LED. Lock drži donju trećinu dok kadar ne stigne, pa je skida ako se gol povuče.
          Story je 9:16 kartica, receipt su vremena isporuke.
        </p>
      </div>
      <div className="mb-3">
        <a className="btn-secondary text-xs" href={demoHref(q.data?.matches)} target="_blank" rel="noreferrer">Demo preview</a>
      </div>
      {q.isError && <div className="alert-bad mb-3">{q.error instanceof ApiError ? q.error.message : String(q.error)}</div>}
      {msg && <div className="card mb-3 p-3 text-sm text-slate-200">{msg}</div>}
      <div className="card overflow-hidden">
        <table className="table">
          <thead>
            <tr><th>Meč</th><th>Status</th><th>Delay</th><th /></tr>
          </thead>
          <tbody>
            {(q.data?.matches ?? []).map((m) => (
              <tr key={m.id}>
                <td>
                  <div className="text-white">{m.home} – {m.away}</div>
                  <div className="text-[11px] text-slate-500">
                    {live(m.status) || m.status === 'finished' ? `${m.score_home}–${m.score_away}` : ''}
                  </div>
                </td>
                <td className="text-slate-300">{live(m.status) ? 'uživo' : m.status}</td>
                <td className="tabular-nums text-slate-400">{m.delay_ms} ms</td>
                <td className="text-right">
                  <a className="btn-ghost text-xs" href={m.onair_url} target="_blank" rel="noreferrer">On-Air</a>
                  {m.story_url && <a className="btn-ghost text-xs" href={m.story_url} target="_blank" rel="noreferrer">Story</a>}
                  {m.receipt_url && <a className="btn-ghost text-xs" href={m.receipt_url} target="_blank" rel="noreferrer">Receipt</a>}
                  <button type="button" className="btn-primary text-xs" onClick={() => copy(m.obs_url)}>OBS</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {(q.data?.matches ?? []).length === 0 && !q.isError && (
          <div className="p-4 text-sm text-slate-500">Nema mečeva. On-Air mora biti uključen na licenci lige.</div>
        )}
      </div>
    </div>
  );
}
